/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect ,useMemo } from 'react';
import MaterialReactTable from "material-react-table";
// import EditIcon from "@mui/icons-material/Edit";
// import { Delete as DeleteIcon } from "@mui/icons-material";
// import { useNavigate, Link as RouterLink } from 'react-router-dom';
// @mui
import {
  // Box,
  Container,
  // IconButton,
  // Button
} from '@mui/material';
// redux
// import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from '../../../redux/store';
import { getRaritys } from '../../../redux/slices/rarity';
// import axios from '../../../utils/axios';
// routes
// import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import Page from '../../../components/Page';
// import Iconify from '../../../components/Iconify';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';

export default function Rarity() {
  // const { enqueueSnackbar } = useSnackbar();

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "ID",
        size: 5,
      },
      {
        accessorKey: "first_name",
        header: "First Name",
        size: 40,
      },
      {
        accessorKey: "last_name",
        header: "Last Name",
        size: 50,
      },
      {
        accessorKey: "email",
        header: "Email",
        size: 50,
      },
      {
        accessorKey: "phone",
        header: "Phone",
        size: 50,
      },
      {
        accessorKey: "amount",
        header: "Amount",
        size: 50,
      },
      {
        accessorKey: "country",
        header: "Country",
        size: 50,
      },
      {
        accessorKey: "zip_code",
        header: "Zip Code",
        size: 50,
      },
      {
        accessorKey: "payment_method",
        header: "Payment Method",
        size: 50,
      },
    ],
    []
  );

  const dispatch = useDispatch();
  const { raritys } = useSelector((state) => state.rarity);

  const [tableData,setTableData]=useState([])

  useEffect(() => {
    dispatch(getRaritys());
  }, []);

  useEffect(() => {
    if (raritys.length) {
      setTableData(raritys);
    }
  }, [raritys]);

  return (
    <Page title="Donation">
      <Container maxWidth='xl'>
        <HeaderBreadcrumbs
          heading="Donation"
          links={[
            { name: '', href: '' },]}
        />
     
          <MaterialReactTable
          columns={columns}
          data={tableData}
        /> 

      </Container>
    </Page>
  );
}


